import React from 'react';
import { Container, Typography } from '@mui/material';

const ProfilePage: React.FC = () => {
  return (
    <Container>
      <Typography variant="h4">Profile</Typography>
      <Typography>User profile functionality coming soon...</Typography>
    </Container>
  );
};

export default ProfilePage;